<template>
  <div class="login">
    <el-main>
      <el-row class="login-container" :gutter="20">
        <el-col :span="24" class="login-card-container">
          <el-card class="login-card">
            <h3>Acesse sua Carteira de Pesca</h3>
            <LoginForm />
          </el-card>
        </el-col>
        <el-col :span="24" class="section-cards-container">
          <el-row :gutter="20">
            <!--<el-col :span="24" class="section-card">
              <SectionCard
                title="Tipos de licença"
                description="Saiba mais sobre os tipos de licença de pesca: Amadora e Esportiva."
                :imgSrc="tiposLicencaImg"
                imgAlt="Ilustração de pescador"
              />
            </el-col>-->
            <el-col :span="24" class="section-card">
              <a :href="contextPath + 'informes-ipaam'" class="card-link">
                <SectionCard
                  title="Informes do IPAAM"
                  description="Fique por dentro das notícias oficiais divulgadas."
                  :imgSrc="informesIpaamImg"
                  imgAlt="Ilustração de pescador"
                />
              </a>
            </el-col>
            <el-col :span="24" class="section-card">
              <div
                @click="showGuiasManuais = true"
                style="width: 100%; cursor: pointer;"
              >
                <SectionCard
                  title="Guias e manuais"
                  description="Faça o download dos manuais."
                  :imgSrc="guiasManuaisImg"
                  imgAlt="Ilustração de guias e manuais"
                />
              </div>
              <GuiasManuaisModal :visible.sync="showGuiasManuais" />
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-main>
  </div>
</template>

<script>
import LoginForm from "../layouts/LoginForm.vue";
import SectionCard from "../layouts/SectionCard.vue";
import GuiasManuaisModal from "../modals/GuiasManuaisModal.vue";

// Importação das imagens
import tiposLicencaImg from "../../assets/imagem-tipos-licenca.png";
import informesIpaamImg from "../../assets/imagem-informes-ipaam.png";
import guiasManuaisImg from "../../assets/imagem-guias-manuais.png";

export default {
  name: "Login",
  components: {
    LoginForm,
    SectionCard,
    GuiasManuaisModal
  },
  data() {
    return {
      tiposLicencaImg,
      informesIpaamImg,
      guiasManuaisImg,
      showGuiasManuais: false
    };
  },
  computed: {
    contextPath() {
      return process.env.VUE_APP_CONTEXT_PATH || "/";
    }
  }
};
</script>

<style scoped>
.login {
  height: 75vh;
  display: flex;
  flex-direction: column;
}

.top-nav {
  background-color: #004d40;
  padding: 10px;
  display: flex;
  justify-content: center;
}

.el-main {
  display: flex;
  justify-content: center;
}

.logo {
  height: 50px;
}

.login-container {
  margin-top: 50px;
  display: flex;
  justify-content: space-between;
  width: 45vw;
  height: fit-content;
}

.login-card {
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}

.login-card h3 {
  color: #295661;
  text-align: center;
  font-family: Nunito;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  padding: 15px 0 25px 0;
}

.login-card-container {
  display: flex;
  justify-content: center;
  border-right: 2px solid #fff;
}

.login-card-container,
.section-cards-container {
  flex: 1;
  padding: 0 31px !important;
}

.login-card,
.section-card {
  flex: 1;
  padding: 0 !important;
}

.section-cards-container .el-row {
  margin: 0 !important;
}

.section-card {
  display: flex;
  padding: 0! !important;
}

.footer {
  text-align: center;
  color: #fff;
  background-color: #004d40;
  padding: 10px;
}

.section-cards-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.section-cards-container .el-row {
  display: flex;
  align-items: center;
  flex-direction: column;
}
@media (max-width: 1360px) {
  .login-container {
    width: 65vw;
  }
}

@media (max-width: 900px) {
  .login-container {
    width: 85vw;
  }
}

@media (max-width: 768px) {
  .login-container {
    flex-direction: column;
    align-items: center;
    margin: 0 30px;
  }

  .login-card-container {
    border-right: none;
  }

  .login-card-container,
  .section-cards-container {
    flex: 1;
  }

  .section-cards-container {
    margin-top: 20px;
  }

  .section-cards-container .el-row {
    flex: 1;
  }
}

.card-link {
  text-decoration: none;
  color: inherit;
  display: block;
}
</style>
